import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false); // Modal state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState(initialState);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);

    emailjs
      .sendForm(
        "service_qaq8zuu",
        "template_plbwnpq",
        e.target,
        "ZYbpRf49_jOyKkq3e"
      )
      .then(
        (result) => {
          console.log(result.text);
          clearState();
          setIsSuccessModalOpen(true); // Show success modal
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Contáctanos</h2>
                <p>
                  Por favor, completa el formulario a continuación para
                  enviarnos un correo electrónico y te responderemos lo antes
                  posible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Nombre"
                        required
                        value={name} // Bind value to state
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Correo Electrónico"
                        required
                        value={email} // Bind value to state
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Mensaje"
                    required
                    value={message} // Bind value to state
                    onChange={handleChange}
                  ></textarea>
                </div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Enviar Mensaje
                </button>
              </form>
            </div>
          </div>
        </div>
        <div
          className="social-icons"
          style={{
            marginTop: "30px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p style={{ marginBottom: "10px", fontWeight: "500" }}>
            Síguenos o contáctanos directamente:
          </p>
          <div style={{ display: "flex", gap: "30px" }}>
            <a
              href="https://www.instagram.com/bhconnectionmkt/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: "40px",
                color: "#E4405F",
              }}
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://wa.me/message/HXDFKP63WDZOL1"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: "40px",
                color: "#25D366",
              }}
            >
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      {isSuccessModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>¡Mensaje enviado!</h2>
            <p>Gracias por contactarnos. Te responderemos lo antes posible.</p>
            <button
              onClick={() => setIsSuccessModalOpen(false)}
              className="btn btn-custom"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}

      {/* Footer */}
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 Design by
            <a href="http://www.koalatech.dev" rel="nofollow">
              KoalaTech
            </a>
          </p>
        </div>
      </div>

      {/* Basic Modal Styles */}
      <style>
        {`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
          }
          .modal-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            text-align: center;
            box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
          }
          .modal-content h2 {
            margin-bottom: 10px;
          }
          .modal-content p {
            margin-bottom: 20px;
          }
         
          
        `}
      </style>
      <style>
        {`
    .social-icons a:hover {
      opacity: 0.8;
      transform: scale(1.2);
      transition: all 0.3s ease-in-out;
    }
  `}
      </style>
    </div>
  );
};
